import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';

import * as yup from 'yup';

/** Description of the token for EAV computed attribute - DTO signature */
export interface EavComputedAttributeTokenInterface {
  /** Token system name (to use in expression) */
  systemName: string;
  /** Token */
  displayName: string;
}

/** Description of the token for EAV computed attribute - DTO schema */
export const EavComputedAttributeTokenDto = SerdeDtoClass.create<EavComputedAttributeTokenInterface>(EavDtoKeysEnum.EAV_COMPUTED_ATTRIBUTE_TOKEN_DTO, {
  systemName: {
    label: 'Машинное имя',
    hint: 'Должно подставляться в выражение в качестве переменной',
    serializer: yup.string(),
  },
  displayName: {
    label: 'Человеко-читаемое имя',
    hint: 'Для пользовательского интерфейса',
    serializer: yup.string(),
  },
});
